<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">课程管理审核</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" @focus="dialogOpen1" style="width:320px;" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择学年学期">
            <el-option v-for="(item,index) in $store.state.termms" :key="index" :label="item.term" :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="course_name" label="课程名称" width="160">
        </custom-table-column>
        <custom-table-column prop="course_no" label="课程编号" width="120">
        </custom-table-column>
        <custom-table-column label="状态" width="150" prop="status" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="120">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导老师" width="120">
        </custom-table-column>
        <custom-table-column prop="class_teacher" label="任课老师" width="120">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="week_start" label="开始周次" width="100">
        </custom-table-column>
        <custom-table-column prop="week_end" label="结束周次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector_start" label="开始节次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector_end" label="结束节次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="people_number" label="班级人数" width="100">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数量" width="100">
        </custom-table-column>
        <custom-table-column prop="school_enterprise_cooperation" :formatter="format_status_iss" label="是否校企合作开发课程"
          width="100">
        </custom-table-column>
        <custom-table-column prop="quality_level" label="精品课程级别" width="100">
        </custom-table-column>
        <custom-table-column prop="class_hour" label="总学时（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="class_content" label="课程内容" min-width="220">
        </custom-table-column>
        <custom-table-column prop="online_course" label="是否有线上课" width="100" :formatter="format_status_iss">
        </custom-table-column>
        <custom-table-column prop="online_course_url" label="线上课程地址" width="160">
        </custom-table-column>
        <custom-table-column prop="course_source" label="课堂教学设计主要选用课程资源" width="240">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleApply(scope.row.id,'pass')" v-if="scope.row.status=='apply'" type="text" size="small">通过</el-button>
            <el-button @click="handleApply(scope.row.id,'refuse')" v-if="scope.row.status=='apply'" type="text" size="small">拒绝</el-button>
          </template>
          <!-- <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
          <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
          <!-- </template> -->
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <custom-table-column fixed prop="course_name" label="课程名称" width="180">
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="week" label="周次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="sector" label="节次" width="100">
        </custom-table-column>
        <!-- <custom-table-column prop="serial_number" label="编号" width="180">
        </custom-table-column> -->
        <custom-table-column label="状态" width="150" prop="status" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数" width="100">
        </custom-table-column>
        <!-- <custom-table-column prop="phone" label="预约电话" width="135">
        </custom-table-column> -->
        <custom-table-column prop="people_number" label="人数" width="100">
        </custom-table-column>
        <!-- <custom-table-column prop="instrument" label="仪器及数量" width="120">
        </custom-table-column> -->
        <!-- <custom-table-column prop="lesson_time" label="开始时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.lesson_time? $until.getTimeStr(new Date(scope.row.lesson_time).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="lesson_end_time" label="结束时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.lesson_end_time? $until.getTimeStr(new Date(scope.row.lesson_end_time).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column> -->
        <custom-table-column prop="class_hour" label="上课学时数（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导教师" width="120">
        </custom-table-column>
        <custom-table-column prop="class_content" label="课程内容" min-width="220" show-overflow-tooltip>
        </custom-table-column>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisibleApply" width="400px">
      <span>{{applyContent}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleApply = false">取 消</el-button>
        <el-button type="primary" @click="updateApplyStatus">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinFormatter],
  data() {
    return {
      classRooms: [],

      formInline: {
        training_room: '',
        status: '',
        structure_1: '',
        course_name: '',
        structure_2: '',
        term: '',
      },
      organLabel: '',
      levell: [1, 2],
      ruleForm: {
        term: '',
        serial_number: '',
        class_name: '',
        lesson_time: '',
        people_number: 0,
        class_content: '',
        instrument: '',
        class_minute: 0,
        teacher: '',
        comment: '',

        training_name: '',
        training_no: '',
      },

      rules: {
        serial_number: [{ required: true, message: '请输入编号', trigger: 'blur' }],
        term: [{ required: true, message: '请输入学年学期', trigger: 'blur' }],
        class_name: [{ required: true, message: '请输入班级名称', trigger: 'blur' }],
        course_name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        teacher: [{ required: true, message: '请输入授课老师', trigger: 'blur' }],
        training_no: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],

        people_number: [
          { required: true, message: '人数不能为空' },
          { type: 'number', message: '人数必须为数字值' },
        ],
        instrument: [{ required: true, message: '请输入仪器及数量', trigger: 'blur' }],
        class_minute: [
          { required: true, message: '授课时长不能为空' },
          { type: 'number', message: '授课时长为数字值' },
        ],

        class_content: [{ required: true, message: '请输入课程内容', trigger: 'blur' }],

        lesson_time: [{ type: 'date', required: true, message: '请选择开始时间', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      dialogVisibleApply: false,
      applyContent: '',
      applyObj: {
        id: '',
        status: '',
      },
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleApply(id, status) {
      if (status == 'pass') {
        this.applyContent = '是否确认审批通过!';
      } else {
        this.applyContent = '是否确认审批拒绝!';
      }
      this.applyObj = {
        id: id,
        status: status,
      };
      this.dialogVisibleApply = true;
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async updateApplyStatus() {
      let res = await this.$api.update.updateCourseApplyStatus(this.applyObj);
      if (res.code == 0) {
        this.applyObj = {
          id: '',
          status: '',
        };
        this.$message.success('操作成功！');
        this.dialogVisibleApply = false;
        this.getList();
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.lesson_time) {
        let timee = params.lesson_time.getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let timee = '';
      if (typeof params.lesson_time == 'string') {
        timee = new Date(params.lesson_time).getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.lesson_time.getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      if (this.ruleForm.lesson_time) {
        this.ruleForm.lesson_time = new Date(this.ruleForm.lesson_time);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery1();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
